<template>
	<div
			:id="id"
			class="divider-element"
			v-bind="$attrs"
	>
		{{ placeholder }}
	</div>
</template>

<script lang="ts" setup>
	defineProps({
		id: {
			type: String,
			required: true
		},
		placeholder: {
			type: String,
			default: ''
		}
	});
	defineOptions({
		inheritAttrs: false
	});
</script>

<style scoped>
	.divider-element {
		white-space: pre-line;

		&:empty {
			display: none;
		}
	}
</style>
